import { ApiException } from '../../api/api';

export function resourceErrorMessage(error: unknown, fallback: string): string {
	if (ApiException.isApiException(error)) {
		try {
			const problem = JSON.parse(error.response);
			if (typeof problem?.detail === 'string' && problem.detail) {
				return problem.detail;
			}
			if (typeof problem?.title === 'string' && problem.title) {
				return problem.title;
			}
		} catch {
			// Non-JSON responses retain the SDK's status/message below.
		}
		return `${error.message} (${error.status})`;
	}
	return error instanceof Error ? error.message : fallback;
}
